module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Pen-tool-vector-4ad48ec0a911dd574a0585938327ec45.svg";